import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div<{ $x: number; $y: number }>`
	position: absolute;
	left: calc(${(props) => props.$x}px * calc(1 / var(--zoom-factor, 1)));
	bottom: calc(${(props) => props.$y}px * calc(1 / var(--zoom-factor, 1)));
	display: flex;
	flex-direction: column;
	row-gap: 21px;
	user-select: none;
	pointer-events: none;

	${Text} {
		color: #ffffff;
		text-shadow: 1px 1px 0px #000000;
	}
`;

const StyledDateTimeContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 6px;
`;

const StyledTimeContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledBankBalanceContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledGameAreaContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 5px;
`;

const StyledMoneyDeposit = styled(Text)<{ $negative?: boolean }>`
	&& {
		color: ${(props) => (props.$negative ? '#FF3737' : '#77de38')};
	}
	font-size: 18px;
	font-weight: 500;
	white-space: nowrap;
	transform: translateX(-10px);
	opacity: 0;

	transition:
		transform 0.75s ease,
		opacity 0.75s ease;

	&.fade-enter {
		transform: translateX(-10px);
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		transform: translateX(0);
		opacity: 1;
	}

	&.fade-exit-active {
		transform: translateX(-10px);
		opacity: 0;
	}
`;

const StyledGreenZoneContainer = styled.div<{ $x: number; $bottom: number }>`
	position: absolute;
	left: calc(${(props) => props.$x}px * calc(1 / var(--zoom-factor, 1)));
	bottom: calc(${(props) => props.$bottom}px * calc(1 / var(--zoom-factor, 1)));
	display: flex;
	gap: 5px;
	align-items: center;
	height: 20px;
	padding: 0 5px;
	background: #111314;
	opacity: 0.75;
	border-radius: 5px;

	${Text} {
		font-weight: 700;
		font-size: 10px;
		color: #77de38;
	}

	&.green-zone-fade-enter {
		opacity: 0;
	}

	&.green-zone-fade-enter-active,
	&.green-zone-fade-enter-done,
	&.green-zone-fade-exit {
		opacity: 1;
	}

	&.green-zone-fade-exit-active {
		opacity: 0;
	}
`;

export {
	StyledBankBalanceContainer,
	StyledContainer,
	StyledDateTimeContainer,
	StyledGameAreaContainer,
	StyledGreenZoneContainer,
	StyledMoneyDeposit,
	StyledTimeContainer,
};
